import moment from "moment";

export function localeFormatDate(value: any) {
	return (value ? moment(value).format('D.M.YYYY') : null);
}

export function localeFormatDateTime(value: any) {
	return (value ? moment(value).format('D.M.YYYY HH:mm') : null);
}
